(ns dashboard.views.settings
  (:require
   [clojure.string :refer [split lower-case]]
   [re-frame.core :as re-frame]
   [breaking-point.core :as bp]
   [headlessui-reagent.core :as ui]
   [dashboard.subs :as subs]
   [dashboard.subs.event-organizer :as event-organizer-subs]
   [dashboard.utils :refer [listen cs href ->ns-first]]
   [dashboard.i18n :refer [tr]]
   [dashboard.views.settings.profile :as profile]
   [dashboard.views.settings.account :as account]
   [dashboard.views.settings.password :as password]
   [dashboard.views.settings.notifications :as notifications]
   [dashboard.views.settings.organization :as organization]
   [dashboard.views.settings.calendars :as calendars]
   [dashboard.views.settings.spaces :as spaces]
   [dashboard.views.settings.users :as users]
   [dashboard.views.settings.roles :as roles]
   [dashboard.views.settings.shifts :as shifts]
   [dashboard.views.settings.billing :as billing]
   [dashboard.views.settings.rooms :as rooms]
   [dashboard.views.settings.bookings :as bookings]
   [dashboard.views.settings.teams :as teams]
   [dashboard.views.settings.events :as events]))

(defn- tab
  [{:keys [route title icon path-params query-params is-active? class is-disabled?]
    :or {path-params {}
         query-params {}
         is-disabled? false}}]
  [:a.px-3.py-2.flex.items-center.text-sm.font-medium.group.border-l-4.focus:outline-none.focus:ring-2.focus:ring-primary-500
   {:class (cs ""
               (when (some? class) class)
               (if is-active?
                 "bg-gray-100 border-primary-500 text-primary-500 hover:bg-gray-200"
                 "border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900"))
    :aria-current (when is-active? "page")
    :href (href route path-params (or query-params (listen ::subs/current-route-query-params)))
    :disabled is-disabled?}
   [:> icon
    {:class (cs "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                (if is-active?
                  "text-primary-500 group-hover:text-primary-500"
                  "text-gray-400 group-hover:text-gray-500"))
     :aria-hidden true}]
   title])

(defn content []
  [:main.relative.-mt-32
   [:div.max-w-screen-xl.mx-auto.pb-6.px-4.sm:px-6.lg:pb-16.lg:px-8
    [:div.bg-white.rounded-lg.shadow.overflow-hidden
     [:div.divide-y.divide-gray-200.lg:grid.lg:grid-cols-12.lg:divide-y-0.lg:divide-x
      [:aside.py-6.lg:col-span-3
       [:nav.space-y-1
        (doall
         (for [route-key (-> (listen ::subs/current-route) :data :sub-routes)
               :let [title (tr (-> (listen :route-for route-key) :data :title))
                     icon (-> (listen :route-for route-key) :data :icon)
                     is-active? (= (listen ::subs/current-route-name) route-key)
                     resource (-> (listen :route-for route-key) :data :resource)]
               :when (if (some? resource)
                       (some? ((into #{} (map :resource (:permissions (listen ::subs/user-role)))) resource))
                       true)]
           ^{:key route-key}
           [tab
            {:route route-key
             :title title
             :icon icon
             :is-active? is-active?}]))]

       ;; Event settings
       [:div.pt-4.mt-2.border-t]
       (when (some? (listen ::event-organizer-subs/selected-event))
         [:div
          [:div.text-gray-500.text-xs.px-2.mb-3.text-semibold.uppercase.truncate
           (if (= (listen ::subs/locale) :ja)
             (tr :settings-fn (:nameJp (listen ::event-organizer-subs/selected-event)))
             (tr :settings-fn (:name (listen ::event-organizer-subs/selected-event))))]
          [:nav.space-y-1
           (doall
            (for [route-key (-> (listen ::subs/current-route) :data :event-settings)
                  :let [title (tr (-> (listen :route-for route-key) :data :title))
                        icon (-> (listen :route-for route-key) :data :icon)
                        is-active? (= (listen ::subs/current-route-name) route-key)
                        resource (-> (listen :route-for route-key) :data :resource)]
                  :when (if (some? resource)
                          (some? ((into #{} (map :resource (:permissions (listen ::subs/user-role)))) resource))
                          true)]
              ^{:key route-key}
              [tab
               {:route route-key
                :path-params {:event-id (listen ::event-organizer-subs/selected-event-id)}
                :title title
                :icon icon
                :is-disabled? (nil? (listen ::event-organizer-subs/selected-event-id))
                :is-active? is-active?}]))]])]
      [:div.lg:col-span-9
       [:div.divide-y.divide-gray-200
        [:div.py-6.px-4.sm:p-6.lg:pb-8
         [:div
          [:h2.text-lg.leading-6.font-medium.text-gray-900
           (tr (listen ::subs/current-route-title))]
          [:p.mt-1.text-sm.text-gray-500
           (listen ::subs/current-route-subtitle)]]]
        (case (listen ::subs/current-route-name)
          :route.settings/profile [profile/content]
          :route.settings/account [account/content]
          :route.settings/password [password/content]
          :route.settings/notifications [notifications/content]
          :route.settings/organization [organization/content]
          :route.settings/calendars [calendars/content]
          :route.settings/spaces [spaces/content]
          :route.settings/users [users/content]
          :route.settings/roles [roles/content]
          :route.settings/shifts [shifts/content]
          :route.settings/billing [billing/content]
          :route.settings/events [events/content]
          :route.settings/rooms [rooms/content]
          :route.settings/bookings [bookings/content]
          :route.settings/teams [teams/content]
          [:div])]]]]]])
